/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetAssetOcppCredentialsRequestDto
 */
export interface SetAssetOcppCredentialsRequestDto {
    /**
     * Plaintext OCPP charger password (hashed server-side)
     * @type {string}
     * @memberof SetAssetOcppCredentialsRequestDto
     */
    password: string;
}

/**
 * Check if a given object implements the SetAssetOcppCredentialsRequestDto interface.
 */
export function instanceOfSetAssetOcppCredentialsRequestDto(value: object): value is SetAssetOcppCredentialsRequestDto {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function SetAssetOcppCredentialsRequestDtoFromJSON(json: any): SetAssetOcppCredentialsRequestDto {
    return SetAssetOcppCredentialsRequestDtoFromJSONTyped(json, false);
}

export function SetAssetOcppCredentialsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetAssetOcppCredentialsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function SetAssetOcppCredentialsRequestDtoToJSON(json: any): SetAssetOcppCredentialsRequestDto {
    return SetAssetOcppCredentialsRequestDtoToJSONTyped(json, false);
}

export function SetAssetOcppCredentialsRequestDtoToJSONTyped(value?: SetAssetOcppCredentialsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
    };
}

